<template>
  <div>

    <div class="super-wrapper">
      <div class="left" :style="getPageSize(true)" >
        <el-tabs v-model="activeRoute" type="card" @tab-click="handleClick" :before-leave="beforeLeave">
      <el-tab-pane name="Personality">
        <span slot="label">Personality</span>
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              1.请阐述你的兴趣起源，告诉我们你有一个怎样的童年，少年，青年时光，是什么激发你对这个专业的兴趣，也可以是从家庭和父母影响等方面来阐述。如果你有其他的个性化事情作为你的兴趣起点，非常欢迎你在这里阐述。
            </template>
            <el-input
              type="textarea"
              v-model="dimension_info.con_1"
              rows="6"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              2.简述一下您父母都是做什么工作的。俗话说，父母是人生最好的启蒙老师。父母给你带来了什么样的积极影响，锻炼了你什么意志，培养了你什么性格，对你所喜爱并且愿意为之付出一生的专业有何影响？
            </template>
            <el-input
              type="textarea"
              v-model="dimension_info.con_2"
              rows="6"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              3.不妨谈谈你的兴趣和爱好。这些内容，也许会作为简历的体现重点，而并非PS，但是对这个问题的回答，有助于我们了解你的性格，内向还是外向，古典还是现代等。能够有助于我们的语言风格更贴近于你。最好不要像简历一样逐条介绍。比如你喜欢古筝，那不妨聊聊它的魅力，为什么吸引你的是古筝而不是风筝。^_^
            </template>
            <el-input
              type="textarea"
              v-model="dimension_info.con_3"
              rows="6"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span class="require-flag">*</span>
              4.坦白来说，我们更希望知道你申请这个专业，个人所拥有的优势和劣势。人无完人，有一个正确科学的自我评估，有助于我们在PS写作中，突出优势，cover劣势。
            </template>
            <el-input
              type="textarea"
              v-model="dimension_info.con_4"
              rows="6"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span class="require-flag">*</span>
              5.最后，我们依然想用一点时间，来请你做个自我介绍。虽然我们填了这么长一个表，似乎就是在做一件事情---自我介绍，但是这里，我们需要你对自己一个更深刻的介绍。这个介绍不是要告诉我们你叫什么，而是要告诉我们你究竟是一个什么样的人。以后想成为一个什么样的人
              。
            </template>
            <el-input
              type="textarea"
              v-model="dimension_info.con_5"
              rows="6"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane v-for="(item, i) in editableTabsNew" :key="i" :name="i + ''">
        <span slot="label">
          {{ item.name }}
        </span>
<!--        <el-button type="success" v-if="item.school && item.school.length > 0 " size="mini" @click="choiceSchooExport(item.school)">-->
<!--          方向相关选校文件下载-->
<!--        </el-button>-->
        <tab_project v-if="version==1" :user_profile="item.value" :ref="'son_' + i"></tab_project>
        <tab_project_v1 v-if="version==2" :user_profile="item.value" :ref="'son_' + i"></tab_project_v1>
      </el-tab-pane>
    </el-tabs>
      </div>
      <div class="right" :style="getPageSize(false)" v-if="show_project_association">
        <hb_abroad_show_project_association ref="project_association" />
      </div>
    </div>
    <HBFixedButton
      class="save-btn"
      v-loading.fullscreen.lock="from_loading"
      @click="submitProfile"
      :desc="infoStatusDesc(study_abroad_information_status)"
    />
  </div>
</template>
<script>
import tab_project from './tab_project.vue'
import tab_project_v1 from "./tab_project_v1.vue";
import {profile_update_two, student_profile} from "@/api/mycenter_studyabroad";
import HBRadioGroupDialog
  from "../HBCommon/HBRadioGroupDialog/HBRadioGroupDialog";
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
import {infoStatusDesc} from '../HBCommon/util'
import { kCacheAbroadInfos } from '../tool';
import hb_abroad_show_project_association from "./abroad_show_project_association";
import {
  getBaseURL
} from '@/utils/auth'
import {
  document_list
} from "@/api/mycenter_studyabroad";
export default {
  name:"TabSeven",
  components: {
    hb_abroad_show_project_association,
    HBRadioGroupDialog,
    tab_project,
    tab_project_v1,
    HBFixedButton
  },
  props: {
    user_profile:{
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      version: 1,
      radioGroupDialogFlag: false,
      radioGroupDialogDatasource: [],
      from_loading: false,
      activeRoute: 'Personality',
      // activeRoute: '0',
      dimension_info: {
        con_1: '',
        con_2: '',
        con_3: '',
        con_4: '',
        con_5: ''
      },
      project_list: [ {
        agent: ''
      }],
      study_abroad_information_status: 0,
      editableTabs: [],
      editableTabsNew: [],
      dimension_info_str: null,
      tag_val: [],
      document: {
        list: [],
        user_id: ''
      },
      show_project_association: false,
      requestData: {
        type: 'ps',
        user_id: this.$route.query.userId,
        loading: ''
      }
    }
  },
  computed: {
  },
  created() {
    this.getUserBindInfo();
  },
  watch: {
    'editableTabs': {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.tag_val = val
          this.studentProfile(this.$route.query.userId,val)
          this.getList()
        }
      },
      immediate: true
    },
    show_project_association: {
      handler(val, oldVal) {
        if (val == true) {
          this.$nextTick(() => {
            this.$refs.project_association.sendItem(this.tab_name)
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    getPageSize(isLeft) {
      var pageHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      var s = `height:${pageHeight - 50}px;`;
      if (isLeft) {
        s = s + `width:${this.show_project_association ? 65 : 100}%`;
      }
      return s;
    },
    handleClick(tab) {
      if (tab.name === 'Personality') {
        this.show_project_association = false
        return
      }
      let that = this
      this.editableTabsNew.forEach(function(item, index) {
        if (tab.name == index) {
          that.tab_name = item.name
        }
      })
      console.log('that.tab_name',that.tab_name)
      if (this.show_project_association === false) {
        this.show_project_association = true
      } else {
        this.$refs.project_association.sendItem(that.tab_name)
      }
    },
    choiceSchooExport(_list) {
      let url
      url = getBaseURL() + '/admin/choice_school/school/choice_school_export_pdf'
      this.document.list = _list
      this.document.type = 'preview'
      this.openPostWindow(url,"rwbc",JSON.stringify(this.document))
    },
    openPostWindow(url, name, data1){
      //创建form表单，以下数form表单的各种参数
      var tempForm = document.createElement("form");
      tempForm.id = "tempForm1";
      tempForm.method = "post";
      tempForm.action = url;
      tempForm.target=name;
      //创建标签 <input></input> 标签 然后设定属性，最后追加为 form标签的子标签
      var hideInput1 = document.createElement("input");
      hideInput1.type = "hidden";
      hideInput1.name="data";
      hideInput1.value = data1;
      tempForm.appendChild(hideInput1);
      if(document.all){
        tempForm.attachEvent("onsubmit",function(){});        //IE
      }else{
        var subObj = tempForm.addEventListener("submit",function(){},false);    //firefox
      }
      document.body.appendChild(tempForm);
      if(document.all){
        tempForm.fireEvent("onsubmit");
      }else{
        tempForm.dispatchEvent(new Event("submit"));
      }
      tempForm.submit();//提交POST请求
      document.body.removeChild(tempForm);//删除整个form标签
    },
    getList() {
      document_list(this.requestData).then((response) => {
        this.tableData = response.data || []
        const tht = this
        this.editableTabsNew.forEach(function(item, index) {
          let name = item.name
          item.school = []
          tht.tableData.forEach(function(ite, inde) {
            if (ite.user_school_choice.project_direction == name) {
              item.school.push(ite.user_school_choice)
            }
          })
        })
      })
    },
    infoStatusDesc(type) {
      return infoStatusDesc(type)
    },
    submitProfile() {
      if (this.editableTabs.length === 0) {
        this.$message({
          message: '学生申请方向不能为空',
          type: 'error'
        })
        return
      }
      this.$confirm("是否确认保存？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitData(this.study_abroad_information_status)
        })
        .catch(() => {});
    },
    submitData(val) {
      this.from_loading = true
      var _dimension_info = this.assemblyData()
      const rData = {'dimension_info': _dimension_info,'activeRoute':this.activeRoute,'activeRouteValue':val, 'user_id':parseInt(this.$route.query.userId)}
      kCacheAbroadInfos(JSON.stringify(rData))
      profile_update_two(rData)
        .then(response => {
          this.from_loading = false
          if (response.code === 200) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          }
          this.studentProfile(parseInt(this.$route.query.userId))
        })
        .catch(error => {
          this.from_loading = false
          this.$message({
              message: error.message,
              type: 'error'
            })
        })
    },
    beforeLeave(activeName, oldActiveName) {
      // console.log('切换')
      // console.log('old',JSON.stringify(JSON.parse(this.dimension_info_str),true) )
      // console.log('new',this.assemblyData() )
      if (this.dimension_info_str && (JSON.stringify(JSON.parse(this.dimension_info_str),true) !== this.assemblyData())) {
        this.$message({
          message: "请先保存当前的修改",
          type: 'error'
        })
        return false
      }
    },
    getUserBindInfo() {
      this.$store
        .dispatch(
          "userAbroad/geUserAbroadData",
          parseInt(this.$route.query.userId)
        )
        .then(() => {
          this.user_bind_info = this.$store.state.userAbroad.userAbroadData;
          this.editableTabs = this.user_bind_info.apply_direction.split(',')
        });
    },
    studentProfile(user_id) {
      student_profile({ 'user_id': user_id })
        .then(response => {
          var value = []
          var that = this
          var related_majors = []
          var editableTabsNew = []
          this.version = response.data.version_dimension || 1
          if (response.data.dimension_info) {
            value = JSON.parse(response.data.dimension_info)
            this.study_abroad_information_status = value.StudyAbroadInformationStatus || 0
            if (value.related_majors.length > 0) {
              related_majors = value.related_majors
            }
          } else {
            value = that.returnStr1()
          }
          this.dimension_info = value
          this.tag_val.forEach(function(item, index) {
            var data = {}
            data.name = item
            if (that.version == 2) {
              data.value = that.returnProjectList()
            } else {
              data.value = that.returnStr2()
            }
            data.StudyAbroadInformationStatus = 0
            for (var i = 0; i < related_majors.length; i++) {
              if (item == related_majors[i].name) {
                data.value = related_majors[i].value
                if (related_majors[i].StudyAbroadInformationStatus) {
                  data.StudyAbroadInformationStatus = related_majors[i].StudyAbroadInformationStatus
                } else {
                  data.StudyAbroadInformationStatus = 0
                }
              }
            }
            editableTabsNew.push(data)
          })
          this.editableTabsNew = editableTabsNew
          value.related_majors = editableTabsNew
          // 数据源
          this.dimension_info_str = JSON.stringify(value)
        })
    },
    returnProjectList() {
      return {
        direction_type: '',
        con_1: '',
        con_2: '',
        con_3: '',
        con_4: '',
        con_5: '',
        con_6: ''
      }
    },
    returnStr1() {
      return {
        con_1:"",
        con_2:"",
        con_3:"",
        con_4:"",
        con_5:"",
        related_majors:[]
      }
    },
    returnStr2() {
      return {
        con_1:"",
        con_2:"",
        con_3:"",
        con_4:"",
        con_5:"",
        con_6:"",
        con_7:"",
        con_8:"",
        major:[{
          con_1:"",
          con_2:"",
          direction:""
        }],
      }
    },
    assemblyData() {
      var data = []
      var re = []
      for (var i = 0; i < this.editableTabsNew.length; i++) {
        var zujian = 'son_' + i
        re = {}
        re.name = this.editableTabsNew[i].name
        re.value = this.$refs[zujian][0].project_list
        if(this.editableTabsNew[i].StudyAbroadInformationStatus){
          re.StudyAbroadInformationStatus = this.editableTabsNew[i].StudyAbroadInformationStatus
        }else {
          re.StudyAbroadInformationStatus = 0
        }
        data[i] = re
      }
      this.dimension_info.related_majors = data
      return JSON.stringify(this.dimension_info)
    }
  }
}
</script>
<style lang="scss" scoped>
.super-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  .left {
    overflow: scroll;
  }
  .right {
    flex: 1;
  }
}
.third-title{
  text-align: left;font-weight: 600;margin-top: 10px
}
.third-title-p{
  text-align: left;font-weight: 600;margin:25px 0 10px 0
}
.require-flag {
  font-size: 20px !important;
  font-weight: 550 !important;
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_seven.vue